import { makeMultiSearch, makeSearch } from "../../UI/Search/Search";
import DepartmentLookupModal from "./DepartmentLookupModal";
import DepartmentService from "../../../Services/Department.service";
const makeSearchArgs = {
    loadOptions: (search, options) => DepartmentService.search(Object.assign(Object.assign({}, options), { query: search })).then(({ data }) => data),
    label: "name",
    value: "id",
};
export const DepartmentSearch = makeSearch(makeSearchArgs);
export const DepartmentMultiSearch = makeMultiSearch(Object.assign(Object.assign({}, makeSearchArgs), { lookupModal: DepartmentLookupModal }));
